export function tryJsonParse<T = unknown>(value: string | null | undefined): T | undefined {
  try {
    return value ? (JSON.parse(value) as T) : undefined;
  } catch {
    return undefined;
  }
}
